import MarqueeRibbon from "react-fast-marquee";

const items = [
  "Intervention rapide",
  "Devis gratuit",
  "Garantie 3 mois",
  "Pièces premium",
];

export const Marquee = () => {
  return (
    <section
      className="relative border-y border-zinc-200 bg-white py-6 overflow-hidden"
      aria-label="Nos engagements"
      data-testid="marquee-section"
    >
      <MarqueeRibbon speed={32} gradient={false} pauseOnHover={false}>
        {items.map((item) => (
          <div key={item} className="flex items-center">
            <span className="font-display text-sm md:text-base font-medium uppercase tracking-[0.35em] text-zinc-600 px-10">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-[#0055FF] shadow-[0_0_12px_rgba(0,85,255,0.9)]" aria-hidden="true" />
          </div>
        ))}
      </MarqueeRibbon>
    </section>
  );
};
